import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const InvalidLinkLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "InvalidLink" */
      './InvalidLink.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
